export const LOGO = "/logos/logo.png";
export const LOGO_FULL = "/logos/logo_full.png";

export const WHATSAPP_URL = "https://wa.me/2250505541313";
export const PHONE_DISPLAY = "+225 05 05 54 13 13";
export const PHONE_DT = "+225 07 48 83 38 40";
export const EMAIL = "groupeautoluxe@gmail.com";
export const WEBSITE = "www.groupeautoluxeci.com";
export const WEBSITE_URL = "https://www.groupeautoluxeci.com";
export const ADDRESS = "Koumassi Remblais, derrière la station PETROCI, 01 BP 924 Abidjan 01, Côte d'Ivoire";
export const FLYER_IMG = "https://customer-assets-rejwkqb3.emergentagent.net/job_web-pro-21/artifacts/i28zmq46_WhatsApp%20Image%202026-09-01%20at%2022.59.13.jpeg";

export const BRANDS = [
  { name: "Toyota", logo: "/brands/toyota.svg" },
  { name: "Hyundai", logo: "/brands/hyundai.svg" },
  { name: "Suzuki", logo: "/brands/suzuki.svg" },
  { name: "Kia", logo: "/brands/kia.svg" },
  { name: "Mazda", logo: "/brands/mazda.svg" },
  { name: "BMW", logo: "/brands/bmw.svg" },
  { name: "Mercedes-Benz", logo: "/brands/mercedes.svg" },
  { name: "Volkswagen", logo: "/brands/volkswagen.svg" },
  { name: "Mitsubishi", logo: "/brands/mitsubishi.svg" },
  { name: "Honda", logo: "/brands/honda.svg" },
  { name: "Ford", logo: "/brands/ford.svg" },
  { name: "Peugeot", logo: "/brands/peugeot.svg" },
  { name: "Audi", logo: "/brands/audi.svg" },
  { name: "Renault", logo: "/brands/renault.svg" },
  { name: "Nissan", logo: "/brands/nissan.svg" },
  { name: "Volvo", logo: "/brands/volvo.svg" },
  { name: "Dacia", logo: "/brands/dacia.svg" },
  { name: "Citroën", logo: "/brands/citroen.svg" },
  { name: "Opel", logo: "/brands/opel.svg" },
  { name: "Fiat", logo: "/brands/fiat.svg" },
];

export const PARTNERS = [
  { name: "Activa Assurances", type: "assurance", logo: "/logos/activa.png" },
  { name: "NSIA Assurances", type: "assurance", logo: "/logos/nsia.png" },
  { name: "Sanlam Allianz", type: "assurance", logo: "/logos/sanlam.png" },
  { name: "GNA-CI Assurances", type: "assurance", logo: "/logos/gnaci.png" },
  { name: "AFG Assurances", type: "assurance", logo: "/logos/afg.png" },
  { name: "SUNU Assurances", type: "assurance", logo: null },
  { name: "VITIB", type: "expertise", logo: "/logos/vitib.png" },
  { name: "SGA", full: "Société Générale de l'Expertise Automobile", type: "expertise", logo: "/logos/sga.png" },
  { name: "BCA", full: "Bureau Central de l'Automobile", type: "expertise", logo: "/logos/bca.png" },
  { name: "Le Conseil de l'Automobile", type: "expertise", logo: "/logos/conseil.png" },
  { name: "Le Paraclet Expertise", type: "expertise", logo: "/logos/paraclet.png" },
  { name: "Cabinet Nouvelle Ivoire Expertise Diomandé", type: "expertise", logo: "/logos/cnied.png" },
];
